import { VisDisplayMode } from '@/types/visualisation';
import { Menu, ButtonWithMenu } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useVisDisplayMode } from '@/hooks/useVisDisplayMode';
import { useState } from 'react';
import { MenuItemWithIcon } from '../menu/MenuItemWithIcon';

const DisplayModeMenuItem = ({
  text,
  onClick,
  isModeSelected,
}: {
  text: string;
  onClick: () => void;
  isModeSelected: boolean;
}) => <MenuItemWithIcon onClick={onClick} text={text} isActive={isModeSelected} />;

export const VisDisplayModeSwitcher = ({
  defaultDisplayMode = VisDisplayMode.BOTH,
}: {
  defaultDisplayMode?: VisDisplayMode;
}) => {
  const { t } = useTranslation('visualisation');
  const [isOpen, setIsOpen] = useState(false);
  const [visDisplayMode, setVisDisplayMode] = useVisDisplayMode(defaultDisplayMode);
  const isModeSelected = (mode: VisDisplayMode) => visDisplayMode === mode;
  const selectDisplayMode = (mode: VisDisplayMode) => {
    setVisDisplayMode(mode);
    setIsOpen(false);
  };
  return (
    // Note: testId does not work on ButtonWithMenu, so I have had to wrap this in a div.
    <div data-testid="vis-display-mode-switcher">
      <ButtonWithMenu
        icon="Mode"
        isOpen={isOpen}
        onClick={() => setIsOpen(true)}
        onOutsideClick={() => setIsOpen(false)}
        placement="bottom-end"
        title={t('displayMode')}
        variant="ghost"
      >
        <Menu testId="vis-display-mode-options-menu">
          <DisplayModeMenuItem
            text={t('displayTable')}
            isModeSelected={isModeSelected(VisDisplayMode.TABLE)}
            onClick={() => selectDisplayMode(VisDisplayMode.TABLE)}
          />
          <DisplayModeMenuItem
            text={t('displayVis')}
            isModeSelected={isModeSelected(VisDisplayMode.VIS)}
            onClick={() => selectDisplayMode(VisDisplayMode.VIS)}
          />
          <DisplayModeMenuItem
            text={t('displayBoth')}
            isModeSelected={isModeSelected(VisDisplayMode.BOTH)}
            onClick={() => selectDisplayMode(VisDisplayMode.BOTH)}
          />
        </Menu>
      </ButtonWithMenu>
    </div>
  );
};
